<template>
  <div
    class="anonymouscall-video-box"
    ref="videoBox"
    :style="{ 'z-index': isPlaying ? 1 : -1 }"
  ></div>
</template>

<script>
import Vap from 'video-animation-player';
import { getVapConfig } from '@/components/VoiceRoom/vapc-mp4-helper';

export default {
  name: 'voiceRoomVideo',
  data() {
    return {
      isPlaying: false,
      vap: null
    };
  },
  created() {},
  methods: {
    async init(src) {
      if (this.isPlaying) {
        return;
      }
      try {
        if (this.vap) {
          this.vap.destroy();
          this.vap = null;
        }
        const config = await getVapConfig(src);
        let width = this.$refs.videoBox ? this.$refs.videoBox.offsetWidth : 450;
        let height = this.$refs.videoBox
          ? this.$refs.videoBox.offsetHeight
          : 700;
        const showHeight = (width * config.info.h) / config.info.w;
        if (height - showHeight > 0) {
          width = (height * config.info.w) / config.info.h;
        } else {
          height = showHeight;
        }
        this.vap = new Vap({
          container: this.$refs.videoBox,
          src: src,
          config: config,
          width: width,
          height: height,

          precache: true,
          accurate: true,
          mute: true,
          type: 'src'
        });
        this.vap.on('ended', () => {
          this.onVideoEnded();
        });
        this.playVideo();
      } catch (error) {
        console.log(error);
        this.onVideoEnded();
      }
    },
    playVideo() {
      this.vap.setTime(0);
      this.isPlaying = true;
      this.vap.play(); // 播放视频
    },
    onVideoEnded() {
      if (this.vap) {
        this.vap.destroy();
        this.vap = null;
      }
      this.isPlaying = false;
      this.$emit('onVideoEnded');
    }
  }
};
</script>
<style lang="scss" scoped>
video {
  width: 100%;
  height: 100%;
}
</style>
<style lang="scss">
.anonymouscall-video-box {
  pointer-events: none;
  canvas {
    pointer-events: none;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}
</style>
